﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260108
*/
'use strict';

const getToken = (params = {}) => {
    return (params.useSession === undefined)
        ? localStorage.getItem(params.tokenNm)
        : sessionStorage.getItem(params.tokenNm);
};
const parseToken = (params = {}) => {
    let payload;
    if ((params.token !== undefined) && (params.token !== null)) {
        const base64UrlPayload = params.token.split('.')[1];
        const base64Payload = base64UrlPayload.replace('-', '+').replace('_', '/');
        payload = JSON.parse(window.atob(base64Payload));
    }
    return payload;
};
const removeToken = (params = {}) => {
    (params.useSession === undefined)
        ? localStorage.removeItem(params.tokenNm)
        : sessionStorage.removeItem(params.tokenNm);
};
const setToken = (params = {}) => {
    (params.useSession === undefined)
        ? localStorage.setItem(params.tokenNm, params.token)
        : sessionStorage.setItem(params.tokenNm, params.token);
};

export {
    getToken,
    parseToken,
    removeToken,
    setToken
}; 

